import { render, staticRenderFns } from "./PagePanelTabs.vue?vue&type=template&id=286921b0&"
import script from "./PagePanelTabs.vue?vue&type=script&lang=js&"
export * from "./PagePanelTabs.vue?vue&type=script&lang=js&"
import style0 from "./PagePanelTabs.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports